import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

function Footer() {
  return (
    <div>
      <footer className={`footer xl:px-24 py-10 px-4 text-base-content shadow-md border border-gray-300`}>
        <aside>
          <img src="/meralogo.jpg" alt="logo" className='w-full h-16 -ml-4' />
          <p className="my-3 md:w-40">
            Savor the artistry where every dish is a culinary masterpiece
          </p>
        </aside>
        <nav>
          <header className="footer-title text-black">Useful links</header>
          <Link to="/about" className="link link-hover">About us</Link>
          <Link to="/events" className="link link-hover">Events</Link>
          <Link to="/blogs" className="link link-hover">Blogs</Link>
          <Link to="/faq" className="link link-hover">FAQ</Link>
        </nav>
        <nav>
          <header className="footer-title">Main Menu</header>
          <Link to="/" className="link link-hover">Home</Link>
          <Link to="/offers" className="link link-hover">Offers</Link>
          <Link to="/allproducts" className="link link-hover">All Products</Link>
        </nav>
        <nav>
          <header className="footer-title">Contact Us</header>
          <a className="link link-hover">himansusekharsahu50@email.com</a>
          <a className="link link-hover">7438023456</a>
        </nav>
      </footer>
      <hr />
      <footer className={`footer items-center xl:px-24 px-4 py-4 mt-2`}>
        <aside className="items-center grid-flow-col text-center">
          <p className="flex items-center justify-center space-x-2">
            <span>Designed and Developed by Himansu</span>
            <span>•</span>
            <span>Copyright © 2024 - All Rights Reserved</span>
          </p>
        </aside>
        <nav className="grid-flow-col gap-4 md:place-self-center md:justify-self-end">
          <a  href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
            </svg>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
            </svg>
          </a>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24" 
              className="fill-current"
            >
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
            </svg>
          </a>
        </nav>
      </footer>
    </div>
  );
}

export default Footer;
